import api from '@/api/api';
import {Distributor} from '@/models/dealers';
import {AxiosResponse} from 'axios';

export default {
    search: (): Promise<AxiosResponse<Distributor>> => {
        return api.get('distributors/v1/');
    },
    performSearchWithFilters: (country: string | null, productLine: string | null): Promise<AxiosResponse<Distributor>> => {
        return api.get('distributors/v1/', {
            params: {
                country,
                productLine
            }
        });
    }
};
